module.exports = __webpack_public_path__ + "img/CM-JN-24-Hyundai-Modern.ff3621a2.jpg";